import StarsIcon from "@material-ui/icons/Stars"

import { CorClara } from "../../../services/functions"

export default function Promocional(props) {
    const { promocional, corSitePrimaria } = props

    // console.log('CorClara', CorClara(corSitePrimaria))

    return (
        <>
            {promocional ? (
                <div
                    className="divPromocional"
                    style={{
                        borderTop: `30px solid ${corSitePrimaria}`,
                        color: `${CorClara(corSitePrimaria) ? "#292929" : "#ffffff"}`,
                    }}
                >
                    <StarsIcon className={"iconPromocional"} />
                </div>
            ) : null}
        </>
    )
}
